import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import {Header} from '../components/Header'
import {CheckPopUpContext} from '../components/DataContext';
import PIDE from "../images/PIDE.jpg";
import React, { useContext, useState, useEffect, useRef, history} from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import useFetchWithOutMsal from '../hooks/useFetchWithOutMsal';
import { protectedResources } from "../authConfig";
import { Navigate, useNavigate } from 'react-router-dom';
import cerrar from "../images/cerrar.png";
import { Helmet } from "react-helmet-async";


export const TipoConductaCAFAM = () => {
    
    const navigate = useNavigate();

    const navigateToHabeasData = () => {
        navigate('/');
        setTimeout(() => {
            window.location.reload();
        }, 100);
    };
    
    const checkPopUpContext2 = useContext(CheckPopUpContext);
    const { tipoConductaSICOF, setTipoConductaSICOF } = checkPopUpContext2 ;

    const handleSeleccion = (opcion) => {
        const ButtonSiguienteTipoDenuncia = document.getElementById("ButtonSiguienteTipoDenuncia")
        const ContainerButtons = document.getElementById("ButtonsTConducta")
        setTipoConductaSICOF(opcion);
        //alert(opcionSeleccionada)
        if (opcion != null) {
            ContainerButtons.style.display='flex';
            ContainerButtons.style.flexWrap= 'wrap';
            ContainerButtons.style.flexDirection= 'row';
            ContainerButtons.style.justifyContent= 'space-around';
        }
        else{
            ContainerButtons.style.display='none';
        }
    }

    const ErrorRegistroDenuncia = () => {
        const FormularioSICOF = document.getElementById("markup");
        FormularioSICOF.style.display = "none";

        const popUpDenunciaExitosa = document.getElementById("ErrorDenuncia");
        popUpDenunciaExitosa.style.display = "block"
        
        var popupPosition = document.getElementById("ErrorDenuncia").offsetTop;

            window.scrollTo({
                top: popupPosition,
                behavior: 'smooth' 
           });
    }

    const ButtontipoConductas = () => {
        const FormularioSICOF = document.getElementById("markup")
        const ContenerdorMadreTConducta = document.getElementById("ContainerTConducta");
        if (tipoConductaSICOF != null) {
            FormularioSICOF.style.display='block';
            FormularioSICOF.style.boxShadow = '2px 3px 10px #1f1f1f';
            ContenerdorMadreTConducta.style.filter = 'blur(1px)';
            ContenerdorMadreTConducta.style.boxShadow = 'none';

            var popupPosition = document.getElementById("markup").offsetTop;

            window.scrollTo({
                top: popupPosition,
                behavior: 'smooth' 
            })
        }
    }

    const CerrarFormularioSICOF = () => {
        const FormularioSICOF = document.getElementById("markup")
        const ContenerdorMadreTConducta = document.getElementById("ContainerTConducta");
        ContenerdorMadreTConducta.style.filter = 'blur(0px)';
        FormularioSICOF.style.display='none';
        ContenerdorMadreTConducta.style.boxShadow= '2px 3px 10px #1f1f1f';
    }

    /*Logica de Registrar Denuncia*/
    const { error, execute } = useFetchWithOutMsal({ });
    const [tipoDoc, setTipoDoc] = useState([]);
    const [region, setRegion] = useState([]);
    const [origen, setOrigen] = useState([]);
    const [area, setArea] = useState([]);
    const [validated, setValidated] = useState(false);
    const [denuncia, setDenuncia] = useState({ data: "", message: "" });

    const [nombresApellidos, setNombresApellidos] = useState('');
    const [tipoDocumentoId, setTipoDocumentoId] = useState('');
    const [numDocumento, setNumDocumento] = useState('');
    const [telefono, setTelefono] = useState('');
    const [regionId, setRegionId] = useState('');
    const [correo, setCorreo] = useState('');
    const [origenId, setOrigenId] = useState('');
    const [areaId, setAreaId] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [archivosValidos, setArchivosValidos] = useState([]);
    const [nombreArchivo, setNombreArchivo] = useState([]);
    const [archivoAdjunto, setArchivoAdjunto] = useState([]);
    const [archivoBoleean, setArchivoBoleean] = useState(false);
    const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@¡¿]+$/;
    const validacionCaracterEspecial = /["'/*%;$#:&()=¿?¡!@0-9]/;
    const validacionEspecialEmail= /["'/*%;$#:&()=¿?¡!]/;
    
    // Definir Variable con el Contexto del primer PopUp
    const checkPopUpContext = useContext(CheckPopUpContext);
    const opcionSeleccionadaPopUp1 = checkPopUpContext.opcionSeleccionadaPopUp1;

    // Definir Variable con el Contexto del primer PopUp
    const checkPopUpContext1 = useContext(CheckPopUpContext);
    const { opcionSeleccionadaPopUp2 } = checkPopUpContext1;

    const extValidas = process.env.REACT_APP_AZURE_EXT_VALIDAS;

    // Definir Variable con el Contexto del primer PopUp
    // const checkPopUpContext2 = useContext(CheckPopUpContext);
    // const { tipoConductaSICOF } = checkPopUpContext2;


     useEffect(() => {
         // Solicitud Tipo GET a la API
         execute("GET", protectedResources.apiDenuncia.endpoint + 'api/tipodocumento').then((response) => {
             //Respues de la Solicitud 
             setTipoDoc(response)
         })

         execute("GET", protectedResources.apiDenuncia.endpoint + 'api/region').then((response) => {
             setRegion(response)
         })

         execute("GET", protectedResources.apiDenuncia.endpoint + 'api/origen').then((response) => {
             setOrigen(response)
         })

         execute("GET", protectedResources.apiDenuncia.endpoint + 'api/area').then((response) => {
             setArea(response)
         })

         execute("GET", protectedResources.apiDenuncia.endpoint + 'api/tipoconducta').then((response) => {
             //setTipoCondunctaSICOF(response)
         })
     }, []);

    const handleFormSubmit = (event) => {
        if (event.currentTarget.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        handleSubmit(event);
    };

    const handleSubmit = (event) => {
        console.log("Clickado")
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.preventDefault();
            configurarEstilosPopUp();
        } else {
            const registraDenuncia = {
                nombres_apellidos: nombresApellidos,
                tipo_documento_id: tipoDocumentoId,
                numero_documento: numDocumento,
                telefono: telefono,
                correo: correo,
                origen_id: origenId,
                area_id: areaId,
                tipo_conducta_id: tipoConductaSICOF,
                region_id: regionId,
                descripcion: descripcion,
                archivo_adjunto: archivoAdjunto,
                check_registrar_denuncia: opcionSeleccionadaPopUp1,
                check_protección_datos: opcionSeleccionadaPopUp2,
                archivo_booleano: archivoBoleean
            };
            execute("POST", protectedResources.apiDenuncia.endpoint + 'api/registradenuncia', registraDenuncia)
                .then((response) => {
                    if (response.status === 'OK') {
                        console.log("Respuesta del servidor: ", response);
                        setDenuncia(response);
                        console.log(denuncia);
                        console.log("Se ha enviado el Formulario");
                        AbrirPopUpDenunciaExitosa();
                    } else {
                        console.log("Respuesta del servidor: ", response);
                        setDenuncia({ data: "", message: "" });
                        ErrorRegistroDenuncia();
                    }
                })
              AbrirPopUpDenunciaExitosa();
        }
        setValidated(true);
    };

    if (error) {
        return <div>Error: {error.message}</div>;
    };

    const handleArchivoChange = async (event) => {
        const target = event.target;
        const files = target.files;
        let totalSize = archivosValidos.reduce((acc, file) => acc + file.size, 0); // Tamaño total de archivos ya seleccionados
        const nuevosArchivosValidos = [];
      
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const extension = file.name.split('.').pop().toLowerCase();
            const extensionesValidas = extValidas.replaceAll('.','').replaceAll(' ','').split(',');
    
            if (!extensionesValidas.includes(extension)) {
                alert("Solo se permiten archivos con extensiones " + extValidas);
                target.value = ''; 
                return; 
            }
            
            if (file.size + totalSize > 20 * 1024 * 1024) {
                alert("El tamaño total de los archivos no puede superar los 15 MB");
                target.value = ''; 
                return; 
            }
            totalSize += file.size; // 
            nuevosArchivosValidos.push(file);
        }
      
        if (nuevosArchivosValidos.length > 0) {
            const nuevosArchivosBase64 = await Promise.all(nuevosArchivosValidos.map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        const base64 = reader.result.split(',')[1];
                        resolve(base64);
                    };
                    reader.onerror = reject;
                });
            }));
        
            setArchivosValidos([...archivosValidos, ...nuevosArchivosValidos]);
            // Agregar nombres y base64 de archivos a la lista de archivo adjunto
            setNombreArchivo([...nombreArchivo, nuevosArchivosValidos.map(file => file.name)]);
            var reader = new FileReader();
            reader.readAsDataURL(target.files[0]);
            reader.onload = function () {
                const base64 = reader.result.split(',')[1];
                const nuevoArchivoAdjunto = {nombre_archivo: target.files[0].name, archivo_base64: base64, tipo_archivo: target.files[0].type};
                archivoAdjunto.push(nuevoArchivoAdjunto);
            }          
            setArchivoBoleean(true);
        }
    };
    
    
    const handleTipoDocChange = (event) => {
        setTipoDocumentoId(event.target.value);
    };
    
    const handleNumDocChange = (event) => {
        if (event.target.value.length > 0) {
            event.target.value = event.target.value.slice(0, 15);
            setNumDocumento(event.target.value);
          }
      };
    

    const handleNombresApellidos = (event) => {
        const divError = document.getElementById('errorNombreApellidos');
        const feedbackFormControl = document.getElementById('feedbackNombreApellidos');
        var input = document.getElementById('inputnombresApellidos');

        if (input.value.trim() !== "") {
            feedbackFormControl.innerHTML = "";
        } else {
            feedbackFormControl.innerHTML = "Digite su Nombre Completo.";
        }

        if (validacionCaracterEspecial.test(input.value)) {
            if (validacionCaracterEspecial.test(input.value)) {
                if (/[0-9]/.test(input.value)) {
                    // Si el valor ingresado contiene un número
                    if (divError) {
                        divError.textContent = 'No se admiten números en este campo';
                        divError.style.color = '#dc3545';
                        divError.style.fontSize = '.850em';
                        divError.style.fontFamily = 'Rubik';
                        divError.style.display = 'block';
                        divError.style.paddingBottom = '-10px';
                    }
                } else {
                    // Si el valor ingresado contiene caracteres especiales pero no números
                    if (divError) {
                        divError.textContent = 'No se admiten caracteres especiales';
                        divError.style.color = '#dc3545';
                        divError.style.fontSize = '.850em';
                        divError.style.fontFamily = 'Rubik';
                        divError.style.display = 'block';
                        divError.style.paddingBottom = '-10px';
                    }
                }
            }
        } else {
            if (divError) {
                divError.textContent = '';
                divError.style.display = 'none';
                setNombresApellidos(input.value);
            }
        }
    };

    const handleTelefonoChange = (event) => {
        if (event.target.value.length > 0) {
            event.target.value = event.target.value.slice(0, 10);
            setTelefono(event.target.value);
          }
    };

    const handleRegionChange = (event) => {
        setRegionId(event.target.value);
    };


    const handleCorreoChange = (event) => {
        const divError = document.getElementById('errorEmail')
        const feedbackFormControl = document.getElementById('feedback');
        var input = document.getElementById('inputCorreo');

        if (input.value.trim() !== "") {
            feedbackFormControl.innerHTML = "";
        }
        else {
            feedbackFormControl.innerHTML = "Digite un correo electrónico válido.";
        };

        if (validacionEspecialEmail.test(event.target.value)) {

            if (divError) {
                divError.textContent = 'Naao se admiten caracteres especiales';
                divError.style.color = '#dc3545';
                divError.style.fontSize = '.875em';
                divError.style.fontFamily = 'Rubik';
                divError.style.display = 'block';
            }
        } else {
            if (divError) {
                divError.textContent = '';
                divError.style.display = 'none';
                setCorreo(event.target.value);
            }
        }
    };

    const handleOrigenChange = (event) => {
        setOrigenId(event.target.value);
    };

    const handleAreaChange = (event) => {
        setAreaId(event.target.value);
    };

    const handleDescripcionChange = (event) => {
        setDescripcion(event.target.value);
    };

    const handleValidateNumDoc  = (event) => {
        const hasError = !emailRegexp.test(event.target.value);
        event.target.validated = false;
    };

    const configurarEstilosPopUp = () => {
        const MostrarPopUpRegistroFallido = document.getElementById("RegistroDenunciaFallidoSICOF");
        MostrarPopUpRegistroFallido.style.width = '30%';
        MostrarPopUpRegistroFallido.style.display = 'flex';
        MostrarPopUpRegistroFallido.style.flexDirection = 'column';
        MostrarPopUpRegistroFallido.style.position = 'absolute';
        MostrarPopUpRegistroFallido.style.flexWrap = 'wrap'; 
        MostrarPopUpRegistroFallido.style.alignItems = 'center'; 
        MostrarPopUpRegistroFallido.style.justifyContent = 'center';
        MostrarPopUpRegistroFallido.style.zIndex = 1;
        MostrarPopUpRegistroFallido.style.color = 'red';
        MostrarPopUpRegistroFallido.style.left = '34.5%';

        var popupPosition = document.getElementById("RegistroDenunciaFallidoSICOF").offsetTop;

            window.scrollTo({
                top: popupPosition,
                behavior: 'smooth' 
            }) 
        // Agregar evento de clic al botón "Aceptar" para cerrar el pop-up
        document.getElementById("cerrarBtn").addEventListener("click", CerrarPopUp);
    };
    
    const CerrarPopUp = () => {
        const popUp = document.getElementById("RegistroDenunciaFallidoSICOF");
        popUp.style.display = "none";
    };

    const AbrirPopUpDenunciaExitosa = () => {
        const FormularioSICOF = document.getElementById("markup");
        FormularioSICOF.style.display = "none";

        const popUpDenunciaExitosa = document.getElementById("ContenedorDenunciaExitosa");
        popUpDenunciaExitosa.style.display = "block"
        
        var popupPosition = document.getElementById("ContenedorDenunciaExitosa").offsetTop;

            window.scrollTo({
                top: popupPosition,
                behavior: 'smooth' 
           });
    }

    const CerrarPopUpDenuncia = () => {
        const popUpDenunciaExitosa = document.getElementById("ContenedorDenunciaExitosa");
        popUpDenunciaExitosa.style.display = "none";
        navigate('/');
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }

    const CerrarPopUpDenunciaExitosa = () => {
        const popUpDenunciaExitosa = document.getElementById("ContenedorDenunciaExitosa");
        popUpDenunciaExitosa.style.display = "none";
        navigate('/');
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }

    const CerrarPopUpDenunciaFallida = () => {
        const popUpDenunciaExitosa = document.getElementById("RegistroDenunciaFallidoSICOF");
        popUpDenunciaExitosa.style.display = "none";
    }

    return (
        <Form>
            <Helmet>
                {/*Enacargado de manejar la seguridad CSP*/}
                <meta httpEquiv="Content-Security-Policy" content={
                            `script-src 'self' 'unsafe-inline';
                            media-src 'self'  https://cdn.jsdelivr.net;
                            style-src 'self';
                            plugin-types ${extValidas};
                            report-uri /endpoint-para-informes; 
                            object-src 'self' 'unsafe-inline';
                            form-action 'self' api/registradenuncia;
                            font-src https://fonts.googleapis.com;`}/>
                {/*Enacargado de manejar la seguridad Missing Anti-clickjacking Header*/}
                <meta http-equiv="X-Frame-Options" content="SAMEORIGIN"/>
            </Helmet>   
            <Header/>
            {/* Parte del tipo de Conducta */}
            <div id="ContainerTConducta">
                <div className='ParteSuperior2'>
                    <div className='TituloSuperiorTConducta'>
                        <h2>¿Qué tipo de conductas puedo denunciar?</h2>
                    </div>
                    <div className='ImgParteSuperior'>
                        <img src={PIDE} alt="Imagen Tipo de Conducta" className='img-tconductas ' />
                    </div>
                </div>
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Check 
                            className='TypeRadio'
                            type="radio"
                            label={<span><strong>Soborno</strong>: Recibir dádivas para adjudicar un beneficio a otro funcionario o a un tercero.</span>}
                            name="opcion"
                            checked={tipoConductaSICOF === '1'}
                            onChange={() => handleSeleccion('1')}
                        />
                        <Form.Check 
                            className='TypeRadio'
                            type="radio"
                            label={<span><strong>Corrupción</strong>: Pago o recibo de beneficios, hechos por o a un colaborador por hacer o abstenerse
                            de hacer algo relacionado con su trabajo.</span>}
                            name="opcion"
                            checked={tipoConductaSICOF === '2'}
                            onChange={() => handleSeleccion('2')}
                        />
                        <Form.Check
                            className='TypeRadio0'
                            type="radio"
                            label={<span><strong>Fraude</strong>: Acto ilegal caracterizado por ser un engaño, ocultación o violación de confianza, que no
                            requiere la aplicación de amenaza, violencia o de fuerza física, perpetrado por individuos y/u organizaciones internos o ajenos a la 
                            Corporación, con el fin de apropiarse de dinero, bienes o servicios.</span> }
                            name="opcion"
                            checked={tipoConductaSICOF === '3'}
                            onChange={() => handleSeleccion('3')}
                        />
                    </Form.Group>
                    <div id='ButtonsTConducta'>
                        <div className="App-button">
                                <Button onClick={navigateToHabeasData}>Volver</Button>
                        </div>
                        <div className="App-button">
                            <Button onClick={ButtontipoConductas} id='ButtonSiguienteTipoDenuncia' >Siguiente</Button>
                        </div>
                    </div>    
                </Form>  
            </div>

            {/* Parte del Formulario para Registrar la Denuncia */}
            <Form noValidate validated={validated} onSubmit={handleSubmit} onSubmitCapture={handleFormSubmit}>
                <div id="markup">
                    <div id='corner-button' onClick={CerrarFormularioSICOF}>
                        <img src={cerrar} className="cerrarFormularioSICOF" alt="" /> 
                    </div>
                    <h1>Registro de Denuncia</h1>
                    <p>En el siguiente formulario por favor describe la situación de la manera más detallada posible.<br></br>
                        *Campos de diligenciamiento obligatorio.</p>
                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Select name='tipo_documento_id' onChange={handleTipoDocChange} required>
                                <option className="d-none" value="">
                                    Seleccione el tipo de identificación *
                                </option>
                                {tipoDoc.map((option) => {
                                    return (
                                        <option key={option.id} value={option.id}>
                                            {option.nombre}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Seleccione un tipo de identificación.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Control required name='numero_documento' onChange={handleNumDocChange} onBlur={handleValidateNumDoc} type="number" min={999999} max={999999999999999} placeholder="Número de identificación *" />    
                            <Form.Control.Feedback type="invalid" >
                                Digite un número de identificación.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Control required name='nombres_Apellidos' onChange={handleNombresApellidos} type="text" placeholder="Nombres y apellidos *" id='inputnombresApellidos' pattern='[a-zA-ZáéíóúiÁÉÍÓÚñÑ\s]+' maxlength="100" />
                            <Form.Control.Feedback type="invalid" id='feedbackNombreApellidos'>
                                Digite Los nombres y apellidos
                            </Form.Control.Feedback>
                            <div className='Error' id='errorNombreApellidos'></div>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Control required name='telefono' onChange={handleTelefonoChange} type="number" min={999999999} max={999999999999999} placeholder="Teléfono *"  />
                            <Form.Control.Feedback type="invalid">  
                                Digite el número de teléfono
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                            <Form.Control required name='correo' onChange={handleCorreoChange} type="email" placeholder="Correo electrónico *"  maxLength={100} id='inputCorreo' />
                            <Form.Control.Feedback type="invalid" id='feedback' >
                                Digite un correo electrónico válido.
                            </Form.Control.Feedback>
                            <div className='Error' id='errorEmail' ></div>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Select required name='origen_id' onChange={handleOrigenChange}>
                                <option className="d-none" value="">Origen de denuncia *</option>
                                {origen.map((option) => {
                                    return (
                                        <option key={option.id} value={option.id}>
                                            {option.nombre}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Seleccione el origen de denuncia.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                            <Form.Select required name='region_id' onChange={handleRegionChange}>
                                <option className="d-none" value="" placeholder='Departamento'>Departamento *</option>
                                {region.map((option) => {
                                    return (
                                        <option key={option.id} value={option.id}>
                                            {option.nombre}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Seleccione el departamento.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Select name='area_id' onChange={handleAreaChange} required>
                                <option className="d-none" value="">Área o negocio involucrado *</option>
                                {area.map((option) => {
                                    return (
                                        <option key={option.id} value={option.id}>
                                            {option.nombre}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Seleccione un área o negocio involucrado.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Control required name='descripcion' onChange={handleDescripcionChange} as="textarea" placeholder="Descripción de los hechos * Máximo 1500 caracteres" rows={8} maxLength={1500}/>
                            <Form.Control.Feedback type="invalid">
                                Digite la descripción de los hechos.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col sm="10">
                            <Form.Control name='archivo' onChange={handleArchivoChange}  accept={extValidas}  type="file" placeholder="Adjuntar Archivo"
                            multiple 
                            />
                            <Form.Text muted className="text-Muded">
                            Tamaño máximo de los archivos: 20 Mb. <br/> 
                            Las evidencias deben remitirse en formato "{extValidas}"
                            <br/>
                            <br/>
                            Archivos seleccionados:
                            <ul>
                                {nombreArchivo.map((nombre, index) => (
                                    <li key={index}>{nombre}</li>
                                ))}
                                </ul>
                            </Form.Text>
                        </Col>
                    </Form.Group>

                    <br />
                    <div className="App-button">
                        <Button variant="primary" type="submit"> 
                            Enviar formulario
                        </Button>
                    </div>
                    <br />
                </div>

                <div id='RegistroDenunciaFallidoSICOF'>
                    <div id='corner-button' onClick={CerrarPopUpDenunciaFallida}>
                        <img src={cerrar} className="cerrarFormularioSICOF" alt="" /> 
                    </div>
                    <p>Debe diligenciar todos los campos para poder continuar</p>
                    <Button id="cerrarBtn">Aceptar</Button>
                </div>

                <div id="ContenedorDenunciaExitosa">
                    <div id='corner-button' onClick={CerrarPopUpDenuncia}>
                        <img src={cerrar} className="cerrarFormularioSICOF" alt="" /> 
                    </div>
                    <div className='ParteSuperiorDenunciaExitosa'>
                        <h2>Registro Enviado</h2> 
                    </div>
                    <div className='CuerpoDenunciaExitosa'>
                        <p>Recibimos tu denuncia exitosamente <br></br>
                        Gracias</p>
                    </div>
                    <div className="App-button">
                        <Button onClick={CerrarPopUpDenunciaExitosa}>Aceptar</Button>
                    </div>
                    <br />
                </div>

                <div id="ErrorDenuncia">
                    <div id='corner-button' onClick={CerrarPopUpDenuncia}>
                        <img src={cerrar} className="cerrarFormularioSICOF" alt="" /> 
                    </div>
                    <div className='ParteSuperiorDenunciaExitosa'>
                        <h2>Registro no enviado</h2> 
                    </div>
                    <div className='CuerpoDenunciaExitosa'>
                        <p>Ocurrio un error al registrar su denuncia, por favor intentelo de nuevo</p>
                    </div>
                    <div className="App-button">
                        <Button onClick={CerrarPopUpDenunciaExitosa}>Aceptar</Button>
                    </div>
                    <br />
                </div>
            </Form>
        </Form>
    );
};

export default TipoConductaCAFAM;